import { AppEntity, ContactPersonId } from '@app/icare/db/schema/common'
import { MedicalTechnologyId } from '@app/icare/entities/medicalTechnology/schema/MedicalTechnology'
import { entityId } from '@pkg/db/schema'
import type { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const PatientMedicalTechnologyId = entityId('patientMedicalTechnology')

export type PatientMedicalTechnologyIdType = typeof PatientMedicalTechnologyId.Type

export const PatientMedicalTechnologyRelationSchema = PatientRelation.extend({
  id: PatientMedicalTechnologyId.schema,
  toId: MedicalTechnologyId.ref,
})

export type PatientMedicalTechnologyRelation = z.infer<typeof PatientMedicalTechnologyRelationSchema>

export const PatientMedicalTechnologyContactPersonId = entityId('patientMedicalTechnologyContactPerson')

export const PatientMedicalTechnologyContactPersonSchema = AppEntity.extend({
  id: PatientMedicalTechnologyContactPersonId.schema,
  ownerId: PatientMedicalTechnologyId.ref,
  contactPersonId: ContactPersonId.ref,
})

export type PatientMedicalTechnologyContactPerson = z.infer<typeof PatientMedicalTechnologyContactPersonSchema>
